// config/apiConfig.js - Centralized API Configuration
// Single source of truth for all API base URLs and versions

/**
 * API Configuration
 * Uses environment variables with fallback to development API
 */
export const API_CONFIG = {
  // Base API URL - uses environment variable or falls back to dev
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.dr.tonicsuite.io',

  // API Version
  VERSION: process.env.REACT_APP_API_VERSION || 'v1.0',

  // Full base URL with version
  get FULL_BASE_URL() {
    return `${this.BASE_URL}/${this.VERSION}`;
  },

  // WebSocket URLs
  WEBSOCKET_URL: process.env.REACT_APP_WS_URL || 'wss://chat.api.dr.tonicsuite.io/',
  WEBSOCKET_CHAT_URL: process.env.REACT_APP_WS_CHAT_URL || 'wss://chat.api.dr.tonicsuite.io/analyser',
  // Web UI Agent (Tonic LiveTest) — local during dev, override via REACT_APP_WS_AGENT_URL in .env
  WEBSOCKET_AGENT_URL: process.env.REACT_APP_WS_AGENT_URL || 'wss://webpilot.api.dr.tonicsuite.io',

  // Environment check
  get IS_DEVELOPMENT() {
    return process.env.NODE_ENV === 'development';
  },

  // Proxy base URL for development (empty string uses relative URLs)
  get PROXY_BASE_URL() {
    return this.IS_DEVELOPMENT ? '' : this.BASE_URL;
  },

  get PROXY_FULL_URL() {
    return this.IS_DEVELOPMENT ? '' : `${this.BASE_URL}/${this.VERSION}`;
  }
};

// Export individual values for backward compatibility
export const BASE_API = API_CONFIG.BASE_URL;
export const API_VERSION = API_CONFIG.VERSION;
export const API_BASE_URL = API_CONFIG.FULL_BASE_URL;
export const WEBSOCKET_URL = API_CONFIG.WEBSOCKET_URL;
export const WEBSOCKET_CHAT_URL = API_CONFIG.WEBSOCKET_CHAT_URL;

// Proxy URLs for development
export const PROXY_BASE_API = API_CONFIG.PROXY_BASE_URL;
export const PROXY_API_VERSION = API_CONFIG.IS_DEVELOPMENT ? '' : API_CONFIG.VERSION;
export const PROXY_API_BASE_URL = API_CONFIG.PROXY_FULL_URL;

/**
 * Helper function to create full URL with base
 * @param {string} path - API path (e.g., '/users/123')
 * @returns {string} Full URL
 */
export const createApiUrl = (path) => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_CONFIG.FULL_BASE_URL}${cleanPath}`;
};

/**
 * Helper function to create proxy URL (for development)
 * @param {string} path - API path
 * @returns {string} Full or relative URL based on environment
 */
export const createProxyUrl = (path) => {
  if (API_CONFIG.IS_DEVELOPMENT) {
    return path.startsWith('/') ? path : `/${path}`;
  }
  return createApiUrl(path);
};

export default API_CONFIG;